import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        brandingPrimary: '#559D37',
        secondary: '#0075A9',
        accent: '#498B2E',
        error: '#C83818',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
        brandingSecondaryLight: '#FF9126',
        brandingSecondary: '#C45500',
        brandingPrimaryDark: '#461A72',
        textPrimary: '#252525',
        textWhite: '#ffffff',
        textSecondary: '#64666B',
        textTertiary: '#767676',
        cardBg: '#FFFFFF',
        pageBg: '#F7F6F6',
        lightGreen: '#DCEDC8',
        amber: '#FFECB3',
        deepOrange: '#FFCCBC',
      },
    },
    icons: {
      iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
  },
} as any);
